import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import { IT_TICKET_URL } from '@shared/utils/support-urls/supportUrls';
import * as React from 'react';

import styles from '../../styles/FeedbackBlocks.module.css';

const NoPermissionsBlock = React.memo((): React.ReactElement => {
  return (
    <InlineFeedback
      type="forbidden"
      message={
        <span className={styles.messageContent}>
          <span>
            You need to have an admin role to add users or organization to CAE
            Connect.
          </span>
          <span>
            To get admin access to CAE Connect, please{' '}
            <CobaltLink href={IT_TICKET_URL} target="_blank" inline>
              open an IT ticket
              <CobaltIconExternalLinkOutline />
            </CobaltLink>{' '}
            requesting to be added to the following group:{' '}
            <span className={styles.groupName}>
              CustomerTrainingPortal-SuperAdmin
            </span>
          </span>
        </span>
      }
    />
  );
});

NoPermissionsBlock.displayName = 'NoPermissionsBlock';

export { NoPermissionsBlock };
